import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { FormTemplateTypeEnum } from "../../../_common/enum/forms/fomTemplateType.enum";
import { FormIndex } from "../../form/form-index";
import { StandardPanel } from "../../../_components/panel/standard.panel";
import { CentreFormManageDrawer } from "./centre-formManageDrawer";

export function CentreFormPanel() {
    const { centreId } = useParams<{ centreId: string }>();
    const navigate = useNavigate();


    return <>
        <StandardPanel title={"Centre Forms"} loading={false} buttons={[
            { label: "+ Create", shrink: true, onClick: () => { navigate("Manage/Forms/") } },
        ]}>
            <FormIndex formType={FormTemplateTypeEnum.Centre} title="Centre Forms" id={centreId} />
        </StandardPanel>

        <Routes>
            <Route path="Manage/Forms/" element={<CentreFormManageDrawer onClose={() => { navigate("") }} />} />
        </Routes>
    </>
}